module.exports = __webpack_public_path__ + "static/umeed-9afa01143302247b0884857f05689378.png";